import ToolBase from '../basic';
import DEFINE from '../define';

export default class Star extends ToolBase {

    name = DEFINE.TOOLS.STAR;

    setting = null;
    star = null;
    isDown = null;
    origX = null;
    origY = null;

    constructor(parent) {
        super(parent);
    }
    
    recover(object) {
        object.set({
            hasBorders: false,
            controls: Object.assign(this.getBasicControls(), {
                mtr: this.getTouchRotateControl({
                    x: 0.5,
                    y: 0,
                    offsetX: 25,
                    offsetY: 0,
                }),
                deleteControl: this.getDeleteControl({
                    x: 0.5,
                    y: -0.5,
                    offsetX: 25,
                    offsetY: 0,
                }),
            })
        })
    }

    mouseUp(o) {
        this.isDown = false;

        this.parent.addHistory();
    }

    mouseDown(o) {
        this.setting = this.parent.getDrawSetting(DEFINE.DRAW_TYPE.SHAPE);

        this.isDown = true;
        this.star = null;
        let pointer = this.getLimitPointer(this.canvas.getPointer(o.e));
        this.origX = pointer.x;
        this.origY = pointer.y;

        if (o.target) {
            this.canvas.discardActiveObject(o.target);
        }
    }

    mouseMove(o) {
        if (!this.isDown) return;

        let pointer = this.getLimitPointer(this.canvas.getPointer(o.e));
        let topY = 3.42; // 此為頂點Y座標
        let scale = Math.sqrt(Math.pow((this.origX - pointer.x), 2) + Math.pow((this.origY - pointer.y), 2)) / Math.pow(topY, 2);

        // 正星星
        // let starPoints = [
        //    { x: this.origX + (0) * scale, y: this.origY - (10) * scale },
        //    { x: this.origX + (2.25) * scale, y: this.origY - (3.09) * scale },
        //    { x: this.origX + (9.51) * scale, y: this.origY - (3.09) * scale },
        //    { x: this.origX + (3.63) * scale, y: this.origY - (-1.18) * scale },
        //    { x: this.origX + (5.88) * scale, y: this.origY - (-8.09) * scale },
        //    { x: this.origX + (0) * scale, y: this.origY - (-3.82) * scale },
        //    { x: this.origX + (-5.88) * scale, y: this.origY - (-8.09) * scale },
        //    { x: this.origX + (-3.63) * scale, y: this.origY - (-1.18) * scale },
        //    { x: this.origX + (-9.51) * scale, y: this.origY - (3.09) * scale },
        //    { x: this.origX + (-2.25) * scale, y: this.origY - (3.09) * scale }
        // ]

        // 肥+星星
        let starPoints = [
            { x: this.origX + (0) * scale, y: this.origY - (10) * scale },
            { x: this.origX + (2.7) * scale, y: this.origY - (3.72) * scale },
            { x: this.origX + (9.51) * scale, y: this.origY - (3.09) * scale },
            { x: this.origX + (4.37) * scale, y: this.origY - (-1.42) * scale },
            { x: this.origX + (5.88) * scale, y: this.origY - (-8.09) * scale },
            { x: this.origX + (0) * scale, y: this.origY - (-4.6) * scale },
            { x: this.origX + (-5.88) * scale, y: this.origY - (-8.09) * scale },
            { x: this.origX + (-4.37) * scale, y: this.origY - (-1.42) * scale },
            { x: this.origX + (-9.51) * scale, y: this.origY - (3.09) * scale },
            { x: this.origX + (-2.7) * scale, y: this.origY - (3.72) * scale }
        ]

        // 肥++星星
        // let starPoints = [
        //    { x: this.origX + (0) * scale, y: this.origY - (10) * scale },
        //    { x: this.origX + (3.09) * scale, y: this.origY - (4.25) * scale },
        //    { x: this.origX + (9.51) * scale, y: this.origY - (3.09) * scale },
        //    { x: this.origX + (4.99) * scale, y: this.origY - (-1.62) * scale },
        //    { x: this.origX + (5.88) * scale, y: this.origY - (-8.09) * scale },
        //    { x: this.origX + (0) * scale, y: this.origY - (-5.25) * scale },
        //    { x: this.origX + (-5.88) * scale, y: this.origY - (-8.09) * scale },
        //    { x: this.origX + (-4.99) * scale, y: this.origY - (-1.62) * scale },
        //    { x: this.origX + (-9.51) * scale, y: this.origY - (3.09) * scale },
        //    { x: this.origX + (-3.09) * scale, y: this.origY - (4.25) * scale }
        // ]

        if (!this.star) {
            this.star = new fabric.Polygon(starPoints, {
                tag: DEFINE.TAG.STAR + new Date().getTime(),
                toolType: this.name,
                angle: 0,
                opacity: this.setting.opacity,
                fill: this.setting.fill,
                stroke: this.setting.stroke,
                strokeWidth: this.setting.strokeWidth,
                cornerColor: DEFINE.COLOR.CORNER_COLOR,
                hasBorders: false,
                transparentCorners: false,
                selectable: true,
                perPixelTargetFind: true,
                paintFirst: "stroke",
                strokeUniform: true,
                controls: Object.assign(this.getBasicControls(), {
                    mtr: this.getTouchRotateControl({
                        x: 0.5,
                        y: 0,
                        offsetX: 25,
                        offsetY: 0,
                    }),
                    deleteControl: this.getDeleteControl({
                        x: 0.5,
                        y: -0.5,
                        offsetX: 25,
                        offsetY: 0,
                    }),
                })
            });
            this.canvas.add(this.star);
        } else {
            let newPolygon = new fabric.Polygon(starPoints, {
                strokeWidth: this.setting.strokeWidth,
            });

            this.star.set({
                points: newPolygon.points,
                height: newPolygon.height,
                width: newPolygon.width,
                pathOffset: newPolygon.pathOffset,
                top: newPolygon.top,
                left: newPolygon.left
            });

            this.star.setCoords();
        }

        this.canvas.renderAll();
    }
}